import { useMemo } from "react";
import { readFormDefinition } from "@froppio/form-core";
import { FormPreview as SharedFormPreview, type FormRendererComponents } from "@froppio/form-renderer";
import { Button } from "@/shared/components/shadcn/Button";
import { Input } from "@/shared/components/shadcn/Input";
import { Select } from "@/shared/components/shadcn/Select";
import { TextArea } from "@/shared/components/shadcn/TextArea";
import { FormField } from "@/shared/components/ui/FormField";
import { Section } from "@/shared/components/ui/Section";
import { EmptyState } from "@/shared/components/ui/EmptyState";

const components = { Button, Input, Select, TextArea, FormField, Section } satisfies FormRendererComponents;

export interface FormPreviewData {
  name: string;
  version: number;
  definition: string;
  versionId?: string;
}

export function FormPreview({ form }: { form: FormPreviewData }) {
  const result = useMemo(() => readFormDefinition(form.definition), [form.definition]);
  return (
    <div className="min-w-0 space-y-6">
      <div>
        <h2 className="break-words text-xl font-bold">{form.name}</h2>
        <p className="text-sm text-muted-foreground">Version {form.version}</p>
      </div>
      {result.success ? (
        <SharedFormPreview key={`${form.versionId ?? form.version}:${form.definition}`} draft={result.draft} components={components} />
      ) : (
        <EmptyState title="This form cannot be previewed" message={`${result.message} The saved definition has not been changed. Review it on the Forms website. Answers and signatures are not submitted or saved.`} />
      )}
    </div>
  );
}
